/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { Link } from 'react-router-dom';

import styles from './DocumentName.module.scss';
type DocType = {
  title: string;
};

export function DocumentName({ title }: DocType) {
  return (
    <Link to={`/chat#${encodeURI(title)}`} className={styles.documentName}>
      {title}
    </Link>
  );
}

export default DocumentName;
